<section class="home-page flex flex-col gap-6 font-display w-full">
  <div class="page-header">
    <div class="min-w-0 flex-1">
      <h1 class="text-xl sm:text-2xl font-bold text-slate-900 leading-snug">
        Dashboard Home
      </h1>
    </div>
  </div>

  <div class="section-card">
    <div class="section-card__header">
      <span class="section-card__title">Quick action</span>
    </div>
    <div class="section-card__body">
      <div class="action-grid">
        <button type="button" (click)="createReimbursement()" class="quick-action-btn">
          <span class="quick-action-btn__icon quick-action-btn__icon--reimburse">
            <i class="fa-solid fa-clipboard-list"></i>
          </span>
          <span class="quick-action-btn__text">
            <span class="quick-action-btn__title">Create reimbursement</span>
          </span>
        </button>
        <button type="button" (click)="createCashAdvance()" class="quick-action-btn">
          <span class="quick-action-btn__icon quick-action-btn__icon--cash-advance">
            <i class="fa-solid fa-credit-card"></i>
          </span>
          <span class="quick-action-btn__text">
            <span class="quick-action-btn__title">Create cash advance</span>
          </span>
        </button>
      </div>
    </div>
  </div>

  <div class="section-card">
    <div class="section-card__header">
      <span class="section-card__title">Statistik</span>
      <mat-select
        [value]="selectedYear"
        (selectionChange)="getStatistic($event)"
        class="year-select"
        placeholder="Pilih tahun"
      >
        <mat-option *ngFor="let year of years" [value]="year">{{
          year
        }}</mat-option>
      </mat-select>
    </div>
    <div class="section-card__body">
      <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div class="chart-card">
          <span class="chart-card__title">Monthly transaction</span>
          <apx-chart
            #chart
            class="w-full max-w-full"
            [series]="chartOptions.series"
            [chart]="chartOptions.chart"
            [dataLabels]="chartOptions.dataLabels"
            [plotOptions]="chartOptions.plotOptions"
            [yaxis]="chartOptions.yaxis"
            [legend]="chartOptions.legend"
            [fill]="chartOptions.fill"
            [stroke]="chartOptions.stroke"
            [tooltip]="chartOptions.tooltip"
            [xaxis]="chartOptions.xaxis"
            [colors]="chartOptions.colors"
          ></apx-chart>
        </div>
        <div class="chart-card">
          <span class="chart-card__title">Status submission</span>
          <div class="flex items-center justify-center py-2">
            <apx-chart
              #donut
              class="w-full max-w-full"
              [series]="chartOptions2.series"
              [chart]="chartOptions2.chart"
              [labels]="chartOptions2.labels"
              [plotOptions]="chartOptions2.plotOptions"
              [responsive]="chartOptions2.responsive"
              [colors]="chartOptions2.colors"
            ></apx-chart>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="section-card">
    <div class="section-card__header">
      <span class="section-card__title">Transaction log</span>
    </div>
    <div class="section-card__body">
      <div
        *ngIf="!reimburseLogs?.length && !cashAdvanceLogs?.length"
        class="empty-state"
      >
        <div class="empty-state__icon">
          <i class="fa-solid fa-inbox"></i>
        </div>
        <span class="font-semibold text-slate-600">Belum ada riwayat transaksi</span>
        <span class="text-xs text-slate-500"
          >Aktivitas akan muncul setelah transaksi diproses</span
        >
      </div>

      <div class="grid grid-cols-1 xl:grid-cols-2 gap-6">
        <div *ngIf="reimburseLogs?.length" class="log-card">
          <div class="log-card__header">
            <div class="min-w-0">
              <span class="log-card__title">Reimburse history approval</span>
              <p class="log-card__meta">
                {{ reimburseData?.title ?? "-" }} · #{{ reimburseData?.refId ?? "-" }}
              </p>
            </div>
            <button
              type="button"
              (click)="detailReimburse(reimburseData?.id)"
              class="btn-link"
            >
              Lihat detail
              <i class="fa-solid fa-arrow-right text-xs"></i>
            </button>
          </div>
          <div class="timeline">
            <div
              class="timeline-item"
              *ngFor="let item of reimburseLogs; let i = index"
            >
              <div class="timeline-item__track">
                <button
                  (click)="openProfile(item?.updater?.id)"
                  class="timeline-item__avatar"
                  [ngClass]="getReimburseLogAccentClass(item)"
                >
                  <img
                    [src]="item?.updater?.imageUrl || 'profile.png'"
                    alt="Profile"
                  />
                </button>
                <div
                  class="timeline-item__line"
                  [ngClass]="getReimburseLogAccentClass(item)"
                  *ngIf="i != reimburseLogs.length - 1"
                ></div>
              </div>
              <div class="timeline-item__content">
                <button
                  (click)="openProfile(item?.updater?.id)"
                  class="timeline-item__name"
                >
                  {{ item?.updater?.firstName }} {{ item?.updater?.lastName }}
                </button>
                <p class="timeline-item__desc">{{ item.description }}</p>
                <span
                  class="timeline-item__time"
                  *ngIf="getLogTimestamp(item) as timestamp"
                >
                  {{ timestamp | date : "d MMM yyyy" }},
                  {{ timestamp | date : "HH:mm" : "+0700" }} WIB
                </span>
                <span
                  class="timeline-item__time timeline-item__time--pending"
                  *ngIf="!getLogTimestamp(item) && isWaitingLog(item)"
                >
                  Menunggu
                </span>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="cashAdvanceLogs.length" class="log-card">
          <div class="log-card__header">
            <div class="min-w-0">
              <span class="log-card__title">Cash advance history approval</span>
              <p class="log-card__meta">
                {{ cashAdvanceData?.title ?? "-" }} · #{{ cashAdvanceData?.refId ?? "-" }}
              </p>
            </div>
            <button
              type="button"
              (click)="detailCashAdvance(cashAdvanceData?.id)"
              class="btn-link"
            >
              Lihat detail
              <i class="fa-solid fa-arrow-right text-xs"></i>
            </button>
          </div>
          <div class="timeline">
            <div
              class="timeline-item"
              *ngFor="let item of cashAdvanceLogs; let i = index"
            >
              <div class="timeline-item__track">
                <button
                  (click)="openProfile(item?.creator?.id)"
                  class="timeline-item__avatar"
                  [ngClass]="getCashAdvanceLogAccentClass(item)"
                >
                  <img
                    [src]="item?.creator?.imageUrl || 'profile.png'"
                    alt="Profile"
                  />
                </button>
                <div
                  class="timeline-item__line"
                  [ngClass]="getCashAdvanceLogAccentClass(item)"
                  *ngIf="i != cashAdvanceLogs.length - 1"
                ></div>
              </div>
              <div class="timeline-item__content">
                <button
                  (click)="openProfile(item?.creator?.id)"
                  class="timeline-item__name"
                >
                  {{ item?.creator?.firstName }} {{ item?.creator?.lastName }}
                </button>
                <p class="timeline-item__desc">{{ item.description }}</p>
                <span
                  class="timeline-item__time"
                  *ngIf="getLogTimestamp(item) as timestamp"
                >
                  {{ timestamp | date : "d MMM yyyy" }},
                  {{ timestamp | date : "HH:mm" : "+0700" }} WIB
                </span>
                <span
                  class="timeline-item__time timeline-item__time--pending"
                  *ngIf="!getLogTimestamp(item) && isWaitingLog(item)"
                >
                  Menunggu
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
